import companyFormModel from "./companyFormModel";

const formField = companyFormModel.formField;

export default {
    [formField.new_connection_type.name]: "",
    [formField.customer_username.name]: "",
    [formField.pin_no.name]: "",
    [formField.sim_type.name]: "",
    [formField.sim_no.name]: "",
    [formField.imei_no.name]: "",
    [formField.assigned_mobile_no.name]: "",
    [formField.will_port_current_no.name]: "",
    [formField.current_prepaid.name]: false,
    [formField.msn_dob.name]: new Date(),
    [formField.current_postpaid.name]: false,
    [formField.current_carrier_account_number.name]: "",
    [formField.target_port_date.name]: new Date(),
    [formField.plan_name.name]: "",
    [formField.plan_term.name]: "",
    [formField.device.name]: "",
    [formField.mpp_total_amount.name]: "",
    [formField.mpp_term.name]: "",
    [formField.mpp_monthly_payment.name]: "",
    [formField.insurance.name]: "",
    [formField.delivery_address.fields.street.name]: "",
    [formField.delivery_address.fields.state.name]: "",
    [formField.delivery_address.fields.postcode.name]: "",
    [formField.special_instruction.name]: "",
};